import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface LeaveUnsavedPricesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Unsaved changes that leaving would lose. */
  count: number;
  /** Leave anyway (the dialog has already been asked to close). */
  onLeave: () => void;
}

/**
 * "Leave without saving?" for Client prices, before any in-app way out that
 * would lose unsaved prices: the Catalogue switch and Back to bill. The edits
 * are lost on leaving, so Leave is the red button and Keep editing (Radix's
 * Cancel) has the focus.
 */
export function LeaveUnsavedPricesDialog({ open, onOpenChange, count, onLeave }: LeaveUnsavedPricesDialogProps) {
  const { t } = useTranslation('inventory');
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>{t('clientPrices.leave.title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('clientPrices.leave.body', { count })}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="h-8 px-3 text-xs">{t('clientPrices.leave.stay')}</AlertDialogCancel>
          <Button
            variant="destructive"
            className="h-8 px-3 text-xs"
            onClick={() => {
              onOpenChange(false);
              onLeave();
            }}
          >
            {t('clientPrices.leave.leave')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
